import { render, staticRenderFns } from "./MessageInifityScroll.vue?vue&type=template&id=6bb2911a&scoped=true&"
import script from "./MessageInifityScroll.vue?vue&type=script&lang=js&"
export * from "./MessageInifityScroll.vue?vue&type=script&lang=js&"
import style0 from "./MessageInifityScroll.vue?vue&type=style&index=0&id=6bb2911a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb2911a",
  null
  
)

export default component.exports